import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

export const ProjectCard = ({ project, index = 0, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y: 50 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.7, delay: (index % 3) * 0.1, ease: [0.22, 1, 0.36, 1] }}
    className={className}
  >
    <Link
      to={`/projects/${project.slug}`}
      className="group block"
      data-testid={`project-card-${project.slug}`}
    >
      <div className="relative overflow-hidden rounded-2xl bg-brand-light aspect-[4/3] ring-1 ring-brand-ink/5 transition-shadow duration-500 group-hover:shadow-[0_24px_60px_-26px_rgba(20,102,214,0.55)]">
        <img
          src={project.image}
          alt={project.title}
          loading="lazy"
          className="h-full w-full object-cover transition-transform duration-[900ms] ease-out group-hover:scale-105"
        />
        <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity duration-500"
          style={{ background: "linear-gradient(135deg, rgba(11,71,184,0.80), rgba(20,102,214,0.55) 55%, rgba(124,196,255,0.45))" }} />
        <div className="absolute top-5 left-5 flex items-center gap-3">
          <span className="text-xs font-semibold tracking-[0.18em] text-brand-ink bg-white/85 backdrop-blur px-3 py-1.5 rounded-full shadow-sm">
            {project.category}
          </span>
        </div>
        <div className="absolute bottom-5 right-5 h-12 w-12 rounded-full bg-white text-brand-primary flex items-center justify-center opacity-0 translate-y-3 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-500 shadow-lg">
          <ArrowUpRight className="h-5 w-5" />
        </div>
      </div>
      <div className="mt-5 flex items-baseline justify-between gap-4">
        <div>
          <span className="text-sm text-brand-magenta font-semibold tracking-widest">{project.id}</span>
          <h3 className="mt-1 font-heading font-bold text-2xl md:text-3xl text-brand-ink group-hover:text-brand-primary transition-colors duration-300">
            {project.title}
          </h3>
        </div>
        <span className="text-sm text-brand-ink/70">{project.year}</span>
      </div>
      <p className="mt-2 text-brand-ink/75 leading-relaxed max-w-md">{project.excerpt}</p>
    </Link>
  </motion.div>
);
